<template>
    <div id="app">
        <div id="cargandoPrincipal" wire:loading
            class="backg fixed top-0 left-0 right-0 bottom-0 w-full h-screen  overflow-hidden bg-gray-700 opacity-80 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4  h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">Espere unos segundos....</p>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Spanish from 'vee-validate/dist/locale/es';

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    watch: {
    },
    created() {
        this.$validator.localize('es', {
            messages: Spanish.messages,
        });
        //this.$socket.start({
        //     // Logging is optional but very helpful during development
        //});
    },
    sockets: {
        ReceiveMessage(message, newTel) {
            // From what i've read this has to be here or the events wont fire
        },
        ReceiveMessageTemplate(message) {
        },
        ReceiveMessageNew(message) {
        },
        UpdateStatus(message) {
            // From what i've read this has to be here or the events wont fire
        },
        UpdateEmojie(message) {
            // From what i've read this has to be here or the events wont fire
        },
        WspLeido(message) {
            //console.log("");
        },
    },
    mounted() {
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                setTimeout(() => {
                    document.getElementById('cargandoPrincipal').style.opacity = 0;
                    setTimeout(() => {
                        document.getElementById("cargandoPrincipal").style.display = "none";
                    }, 1500);
                }, 1000);
            }
        }
    },

    methods: {
        getCookie(name) {
            const cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                let c = cookies[i].trim().split("=");
                if (c[0] === name) {
                    return decodeURIComponent(c[1]);
                }
            }
            return "";
        },
    },

}
</script>

<style src="./styles/app.scss" lang="scss">
//Loading
.backg {
    z-index: 200000 !important;
}

.loader {
    border-top-color: #3498db;
    -webkit-animation: spinner 1.5s linear infinite;
    animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.opacity-10 {
    transition: opacity 2s linear;
    width: 40px;
    height: 40px;
    opacity: 1.0 !important;
}
</style>
